import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { UrlConnectionEnum } from 'src/app/enums/connection/url-connection.enum';
import { HttpService } from '../http-service/http.service';

@Injectable({
    providedIn: 'root'
})
export class ActivationListService {

    constructor(private httpService: HttpService) { }

    /**
     * Gets activation list
     * @author Starley Cazorla
     * @param configData
     * @returns
     */
    async getActivationList(configData: any) {
        let config = this.httpService.setHeaderConfig(true);
        return lastValueFrom(this.httpService.get(UrlConnectionEnum.GET_ACTIVATION_LIST, configData, config));
    }

}
